module.exports = __webpack_public_path__ + "static/media/ico_cnf_ext-26.fe42c709.svg";